import React, { Component } from 'react'
import { Field as Input } from 'redux-form'

import { TextInput } from '../Inputs'


class NumberInput extends Component {
  validateValue = (value) => {
    const { minimum, maximum } = this.props.field
    const hasValue = !(value === null || value === undefined)
    const hasMinimum = !(minimum === null || minimum === undefined)
    const hasMaximum = !(maximum === null || maximum === undefined)

    if (hasMinimum || hasMaximum) {
      if (hasValue && hasMinimum && value < minimum) {
        return `Debe ser mayor o igual a ${minimum}`
      } else if (hasValue && hasMaximum && value > maximum) {
        return `Debe ser menor o igual a ${maximum}`
      }
    }
  }

  checkDefaultValue = (field) => {
    if (field.enum && field.enum.length === 1){
      return { value : field.enum[0], readOnly : true }
    } else {
      return {}
    }
  }

  render() {
    const { name, disabled } = this.props.field

    return (
        <Input
            key={`ds-${name}`}
            name={name}
            inputProps={this.checkDefaultValue(this.props.field)}
            type="number"
            required={false}
            component={TextInput}
            disabled={disabled}
            validate={this.validateValue}
            parse={value => Number(value)}
        />
    )
  }
}

export default NumberInput
